import { Autocomplete, TextField } from '@mui/material'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'

interface FormInputAutoCompleteProps<T, TFieldValues extends FieldValues> {
  name: Path<TFieldValues>
  control: Control<TFieldValues>
  label: string
  options: T[]
  getOptionLabel: (option: T) => string
  getOptionById: (id: any, options: T[]) => T | null
  isOptionEqualToValue: (option: T, value: T | null) => boolean
  onChangeValue: (option: T | null) => any
  readonly?: boolean
  disabled?: boolean
}

export const FormInputAutoComplete = <T, TFieldValues extends FieldValues>({
  name,
  control,
  label,
  options,
  getOptionLabel,
  getOptionById,
  isOptionEqualToValue,
  onChangeValue,
  readonly,
  disabled,
}: FormInputAutoCompleteProps<T, TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        const selectedOption = getOptionById(value, options)

        return (
          <Autocomplete
            options={options.sort((a, b) =>
              getOptionLabel(a).localeCompare(getOptionLabel(b), 'pt-BR', { sensitivity: 'base' }),
            )}
            getOptionLabel={getOptionLabel}
            isOptionEqualToValue={isOptionEqualToValue}
            value={selectedOption || null}
            noOptionsText={''}
            onChange={(_, data) => onChange(onChangeValue(data))}
            readOnly={readonly}
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                size={'small'}
                error={!!error}
                helperText={error ? error.message : null}
                variant='outlined'
              />
            )}
          />
        )
      }}
    />
  )
}
